import spartaGlobalFunctions from "utilities/global/sparta-global-functions-utility/2.1.3/js/sparta-global-functions-utility";
import _ from "utilities/vendor/lodash/4.17.21/js/lodash.custom.min";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import spartaInputErrorUtility from "utilities/global/sparta-input-error-utility/7.2.3/js/sparta-input-error-utility";
import spartaMaskingUtility from "utilities/global/sparta-masking-utility/5.3.0/js/sparta-masking-utility";
import spartaTemplatesUtility from "utilities/global/sparta-templates-utility/2.0.0/js/sparta-templates-utility";
import spartaMediaQueryConstantsUtility from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/sparta-mediaquery-constants-utility";
import spartaAccordionUtility from "utilities/global/sparta-accordion-utility/8.4.1/js/sparta-accordion-utility";
import spartaBrowserSupportUtility from "utilities/global/sparta-browser-support-utility/4.5.2/js/sparta-browser-support-utility";
import spartaEventsUtility from "utilities/global/sparta-events-utility/2.3.5/js/sparta-events-utility";
import spartaFootnoteUtility from "utilities/global/sparta-footnote-utility/4.4.1/js/sparta-footnote-utility";
import spartaInputFormattingUtility from "utilities/global/sparta-input-formatting-utility/2.1.1/js/sparta-input-formatting-utility";
import spartaInputUtility from "utilities/global/sparta-input-utility/13.0.5/js/sparta-input-utility";
import spartaMediaQueryUtility from "utilities/global/sparta-mediaquery-utility/2.0.4/js/sparta-mediaquery-utility";
import Module from "utilities/global/sparta-module-utility/6.2.6/js/sparta-module-utility";
import spartaStickyUtility from "utilities/global/sparta-sticky-utility/4.0.4/js/sparta-sticky-utility";
import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import spartaTransportUtility from "utilities/global/sparta-transport-utility/4.1.0/js/sparta-transport-utility";
import spartaUILayersUtility from "utilities/global/sparta-ui-layers-utility/5.7.7/js/sparta-ui-layers-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.7/js/sparta-validation-framework";
/* eslint-disable import/prefer-default-export, no-undef */

/**
 * Passes back references to all global dependencies.
 * @example const { Module, spartaEventsUtility} = getGlobalDependencies();
 * @returns {Object} Dependencies.
 */
export default function getGlobalDependencies() {
  return {
    // Globals
    Module,
    spartaAccordionUtility,
    spartaBrowserSupportUtility,
    spartaEventsUtility,
    spartaFootnoteUtility,
    spartaGlobalFunctions,
    spartaInputErrorUtility,
    spartaInputFormattingUtility,
    spartaInputUtility,
    spartaMaskingUtility,
    spartaMediaQueryUtility,
    spartaMediaQueryConstantsUtility,
    spartaStickyUtility,
    spartaStoreUtility,
    spartaStyleUtility,
    spartaTemplatesUtility,
    spartaTransportUtility,
    spartaUILayersUtility,
    spartaValidationFramework,

    // Vendor
    jQuery,
    $: jQuery,
    _,
  };
}
